export default { bullets: [{ bulletText: "Support ticket management" }, { bulletText: "Creative requests" }] };
